<template>
    <div class="accordian-section">
        <div class="group outline-none" :tabindex="index + 1" v-for="(section, index) in labels"
            :class="index > 0 ? 'border-t' : ''" @click="set(index)">
            <div class="group group-focus:bg-[var(--dark-grey)] flex justify-between px-4 py-3 items-center transition ease duration-500 cursor-pointer pr-10 relative"
                :class="{ 'bg-[var(--dark-gray)]': value === index }">
                <div class="transition ease duration-500 font-semibold select-none accordian-section-title">
                    {{ section }}
                </div>
                <div class="h-8 w-8 items-center inline-flex justify-center transform transition ease duration-500 group-focus:-rotate-180 absolute top-0 right-0 mb-auto ml-auto mt-2 mr-2"
                    :class="{ '-rotate-180': value === index }">
                    <Icon name="material-symbols:keyboard-arrow-down" class="text-[var(--light-gray)] text-xl" />
                </div>
            </div>
            <div class="group-focus:max-h-screen max-h-0 px-4 overflow-hidden ease duration-500"
                :class="{ 'max-h-screen': value === index }">
                <p class="py-4 accordian-section-content lg:text-justify">
                    <slot :name="`section-${index + 1}`"></slot>
                </p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';

export default {
    props: {
        labels: {
            type: Array as PropType<string[]>,
            required: true,
        },
        modelValue: {
            type: Number,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            value: this.modelValue,
            // checked: 0,
            // name: 'accordion' + Math.floor(Math.random() * 1000),
        };
    },
    watch: {
        modelValue() {
            this.value = this.modelValue;
        },
    },
    methods: {
        set(index: number) {
            this.value = index;
            this.$emit('update:modelValue', this.value);
        },
    },
};
</script>
